import React, { useState } from 'react';
import PropTypes from 'prop-types'
import '../QueuePage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';

const QueueFilterCheckbox = props => {
    const { name, elementId, onClick, isChecked } = props;

    const handleCheckboxChange = (event) => {
        onClick(event.target.checked);
    };

    return (
        <div>
            <input type='checkbox' className='queue-filter-checkbox-custom' id={elementId} checked={isChecked} onChange={handleCheckboxChange} />
            <HrbTranslate className='checkbox-text' text={name} />
        </div>
    )
}

QueueFilterCheckbox.propTypes = {
    name: PropTypes.string,
    elementId: PropTypes.string
}

export default QueueFilterCheckbox